module.exports = "/packs/logo-pc-95865822e9ffb190ca4cb5a54ef8bf8b.svg";